import {ResourceParams} from "../resources";

export type RatingReputationResourceType =
  'feedbacks' |
  'daily-feedback-reports';

export const ratingReputationResources: {
  [key in RatingReputationResourceType]: ResourceParams
} = {
  'feedbacks': {
    key: 'feedbacks',
    name: 'Отзывы',
    path: 'feedbacks'
  },
  'daily-feedback-reports': {
    key: 'daily-feedback-reports',
    name: 'Аналитика отзывов',
    path: 'daily-feedback-reports'
  }
};
